Ext.define('SA.data.quickreport.QuickReportTemplateValueCache', {
    statics: {
        get(templateId) {
            var caches = this.caches = (this.caches || {}),
                cache = caches[templateId] = (caches[templateId] || new this());

            return cache;
        }
    },

    constructor() {
        this.cache = {};
    },

    addEntries(entries) {
        Ext.Object.merge(this.cache, entries);
    },

    getEntries(locations) {
        var result = {};

        locations.forEach(location => {
            result[location] = this.cache[location];
        });

        return result;
    },

    hasEntry(location) {
        return location in this.cache;
    }
});